import { render, staticRenderFns } from "./MoveItineraryAlert.vue?vue&type=template&id=5aea4322&scoped=true&"
import script from "./MoveItineraryAlert.vue?vue&type=script&lang=js&"
export * from "./MoveItineraryAlert.vue?vue&type=script&lang=js&"
import style0 from "./MoveItineraryAlert.vue?vue&type=style&index=0&id=5aea4322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aea4322",
  null
  
)

export default component.exports